import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import _ from 'lodash';

class Nav extends Component {

    state = {
        isToggle: ""
    }

    toggleNav = () => {
        const isToggle = _.isEmpty(this.state.isToggle) ? 'in' : '';

        this.setState({
            isToggle
        })
    }

    logout = () => {
        sessionStorage.clear();
    }

    render() {

        const { page } = this.props;
        const token = sessionStorage.getItem('token');
        const sports = [
            { desc: 'Golf', route: 'golf' },
            { desc: 'Baseball', route: 'baseball' },
            { desc: 'Cycling', route: 'cycling' },
            { desc: 'Hockey', route: 'hockey' },
            { desc: 'Hiking/Treking', route: 'hiking-treking' },
            { desc: 'Tennis', route: 'tennis' },
            { desc: 'Board Sports', route: 'board-sports' }
        ]

        const setActiveClass = (route) => {
            if(page !== route) return null;
            return 'active';
        }

        return (
            <div>
                <div className="nav-wrapper main-nav">
                    <div className="container">
                        <nav className="navbar navbar-default" alt="navigation">
                            <div className="navbar-header">
                                <button 
                                onClick={this.toggleNav} 
                                type="button" 
                                className="navbar-toggle" 
                                data-toggle="collapse" 
                                data-target=".navbar-ex1-collapse">
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </button>
                                <a className="navbar-brand hidden-xs hidden-sm" href="">Select Sports</a>
                            </div>

                            <div className={`collapse navbar-collapse ${this.state.isToggle} navbar-ex1-collapse`}>
                                <ul className="nav navbar-nav">
                                    <li><a href="http://www.wrightbalance.com" target="_blank" rel="noopener noreferrer">Golf School</a></li>

                                    { sports.map((item,index) => {
                                        return (
                                            <li key={`nav_${index}`} className={setActiveClass(item.route)}>
                                                <Link to={`/page/${item.route}`}>{ item.desc }</Link>
                                            </li>
                                        )
                                    })}
                                </ul>
                                <ul className="nav navbar-nav navbar-right">
                                    <li className="dropdown">
                                        <a href="" className="dropdown-toggle" data-toggle="dropdown">More <b className="caret"></b></a>
                                        <ul className="dropdown-menu">
                                            <li><a href="">Skate Boarding</a></li>
                                            <li><a href="">Basketball</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
                { _.isNil(token)
                    ? <div className="container visible-xs">
                        <div className="row" style={{marginTop: 10, marginBottom: 10}}>
                            <div className="col-xs-6 text-center">
                                <Link to="/sign-in" className="btn btn-sm btn-primary btn-block">Sign In</Link>
                            </div>
                            <div className="col-xs-6">
                                <Link to="/sign-up" className="btn btn-sm btn-success btn-block">Join Now</Link>
                            </div>
                        </div>
                    </div>
                    : <div className="container visible-xs">
                        <div className="row" style={{marginTop: 10, marginBottom: 10}}>
                            <div className="col-xs-6 text-center">
                                <Link to="/sign-in" onClick={this.logout} className="btn btn-sm btn-primary btn-block">Logout</Link>
                            </div>
                            <div className="col-xs-6 text-center">
                                <Link to="/profile" className="btn btn-sm btn-primary btn-block">Profile</Link>
                            </div>
                        </div>
                    </div>
                }
                
            </div>
        );
    }
}

export default Nav



// WEBPACK FOOTER //
// ./src/partials/Nav.js